import { config } from './create-config'

import {
  useControls,
} from "leva";

export function ConfigWrapper() {

    const configPanel = useControls({ configObj: config()})
    return (
    <pre>
    </pre>
  )
}